window.$ = window.jQuery = require('jquery')
require('bootstrap')
import slick from 'slick-carousel';
const Swal = require('sweetalert2');

$(document).ready(function() {

    $('#send_message').on('click', function () {
        let url = document.querySelector('meta[name="home"]').getAttribute('content')+'/send_message';

        if($('#email').val() == '' || $('#phone').val() == '' || $('#name').val() == '' || $('#text').val() == '') {
            Swal.fire($('#send-message-error-text').val());
            return false;
        } 

        $.ajax({
            type: "POST",
            url: url,
            headers: {'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')},
            data: {
                'email' : $('#email').val(),
                'phone' : $('#phone').val(),
                'name' : $('#name').val(),
                'text' : $('#text').val(),
            },
            success: function(response) {
                Swal.fire(response.message);
            }
        });
    });


    if($('.nav-block .header-menu .dropdown').children('.dropdown-menu').length > 0 ) {
        $('.nav-block .dropdown-menu').parent().addClass('parent');
    }

   

    function onLoad () {
        let offsetLeft = ( $(document).width() - $('.container').width() ) / 2;

        if ( $('.he') ) {
            if($(window).width() > 767) {

                if ($('.slider').length) {
                    $('.text-wrapper').css({
                        'right' : offsetLeft,
                        'opacity' : 1,
                    });
                    
                }
            } else {
                $('.text-wrapper').css({
                    'right' : 0,
                });
            }
        }


        if($(window).width() > 767) {
            if ($('.slider').length) {
                $('.text-wrapper').css({
                    'left' : offsetLeft,
                    'opacity' : 1,
                });
                
                $('.slider .bottom-info').css({
                    'left' : offsetLeft,
                });

                $('.slider .slider-items .slick-dots').css({
                    'right' : offsetLeft,
                });

            }
        } else {
            $('.text-wrapper').css({
                'left' : 0,
            });
            
            $('.slider .bottom-info').css({
                'left' : 0,
            });


            $('.slider .slider-items .slick-dots').css({
                'right' : 0,
            });
        }
            

        $(".slider-items").on("beforeChange", function (){
            $('.text-wrapper h4').removeClass('showUp').delay(1000).addClass('showUp');
        });
        $('.text-wrapper h2').addClass('showUp');
        $('.text-wrapper h4').addClass('showUp');



        if($(window).width() > 767) {

            if($('#team')) {
                let teamHg = $('#team .team-slider').height();
                $('#team .info').animate({
                    'height' : teamHg,
                });
            }
        } else {
            if($('#team')) {
                $('#team .info').animate({
                    'height' : 'auto',
                });
            }
        }

        if ( $('.service-block')) {
            let picHeight = $('.service-block .services .image').height();

            $('.service-block .services .text').animate({
                'height' : picHeight,
                // 'opacity' : 1,
            });
        }
       


        let mapHeight = $('.contact-block .footer-content').height();

        if ( $('.contact-block')) {
            $('.contact-block .map').animate({
                'height' : mapHeight,
            });
        }

    }

    $('#down').on('click', function () {
        $('#navbar').removeClass('show');
        $('.nav-block .header-menu .navbar-default .navbar-header .navbar-toggle').addClass('collapsed');
    })


    $('.slider-items').slick({
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: true,
        infinite: true,
        speed: 800,
        slidesToShow: 1,
        arrows: false,
        // nextArrow: '<i class="fas fa-chevron-right"></i>',
        // prevArrow: '<i class="fas fa-chevron-left"></i>',
    });



    $('.about-slider').slick({
        dots: true,
        infinite: true,
        speed: 500,
        fade: true,
        speed: 1500,
        autoplay: true,
        autoplaySpeed: 4000,
        cssEase: 'linear',
        arrows: false,
    });




    $('.team-slider').slick({
        lazyLoad: 'ondemand',
        infinite: true,
        slidesToScroll: 1,
        rtl: true,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: true,
        infinite: true,
        speed: 1200,
        slidesToShow: 4,
        asNavFor: '#team .info',
        arrows: true,
        nextArrow: '<i class="fas fa-chevron-right"></i>',
        prevArrow: '<i class="fas fa-chevron-left"></i>',
        responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
              }
            },
        ]
    });

    $('#team .info').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.team-slider',
        speed: 2000,
        autoplaySpeed: 5000,
        autoplay: true,
        lazyLoad: 'ondemand',
        rtl: true,
    });

     
    $('#services .servislider').slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: false,
        speed: 1500,
        autoplaySpeed: 3000,
        autoplay: true,
        lazyLoad: 'ondemand',
         responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
              }
            },
            {
              breakpoint: 767,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            },
        ]
    });



    $(window).on('load resize', function() {
        onLoad();
    });

    $('#down').on('click', function() {
        $('.navbar-nav li').removeClass('active');
        $(this).addClass('active');
    })
})



// WEBPACK FOOTER //
// ./resources/assets/js/site/app.js